/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getItem = `query GetItem($id: ID!) {
  getItem(id: $id) {
    id
    name
    description
    category
    cost
    vendor
    itemNumber
    location
    vendorLink
    nwItemNumber
    swItemNumber
    imageUrl
  }
}
`;
export const listItems = `query ListItems(
  $filter: ModelItemFilterInput
  $limit: Int
  $nextToken: String
) {
  listItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      category
      cost
      vendor
      itemNumber
      location
      vendorLink
      nwItemNumber
      swItemNumber
      imageUrl
    }
    nextToken
  }
}
`;



// WEBPACK FOOTER //
// ./src/graphql/queries.js